import axios from 'axios'
import {Message} from 'element-ui'

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response.status === 401) {
    Message({
      message: '登录失效，请重新登录',
      type: 'error',
    })
    setTimeout(() => {
      window.location.href = '/login'
    }, 200)
  } else if (error.response.status === 500) {
    Message({
      message: '接口异常',
      type: 'error',
    })
  }
  return Promise.reject(error)
})
